export default __webpack_public_path__ + "static/media/myb-watches.33f7a31a.jpg";